var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsAfterHoursActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17.658 17.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "time-half-past-svgrepo-com",
    d: "M8.093,10.1a1.46,1.46,0,0,1,0-2.535V5.15a.736.736,0,1,1,1.472,0V7.561a1.46,1.46,0,0,1,0,2.535v1.675a.736.736,0,1,1-1.472,0ZM8.829,0a.736.736,0,0,0,0,1.472,7.358,7.358,0,1,1,0,14.715.736.736,0,0,0,0,1.472A8.829,8.829,0,0,0,8.829,0ZM1.344,4.991a.736.736,0,1,0,.736.736A.736.736,0,0,0,1.344,4.991Zm.127,3.838a.736.736,0,1,0-.736.736A.736.736,0,0,0,1.472,8.829ZM3.106,2.36a.736.736,0,1,0,.736.736.736.736,0,0,0-.736-.736ZM5.723.619a.736.736,0,1,0,.736.736A.736.736,0,0,0,5.723.619ZM1.344,11.2a.736.736,0,1,0,.736.736A.736.736,0,0,0,1.344,11.2Zm1.761,2.632a.736.736,0,1,0,.736.736A.736.736,0,0,0,3.106,13.827Zm2.618,1.741a.736.736,0,1,0,.736.736.736.736,0,0,0-.736-.736Z",
    fill: "#1450ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAfterHoursActiveIcon);
export default __webpack_public_path__ + "static/media/settings-after-hours-active-icon.28e848ee156ddd56fc20cc924bfbd3f0.svg";
export { ForwardRef as ReactComponent };